import React, { FC, useContext } from 'react';
import { WithStyle } from '../../utils/with-style';
import { ModalBodyStyled } from './modal.styled';
import ModalContext from './modal-context';

const ModalBody: FC & WithStyle = props => {
  const contextProps = useContext(ModalContext);
  return (
    <ModalBodyStyled {...contextProps} {...props}>
      {React.Children.map(props.children, content => content)}
    </ModalBodyStyled>
  );
};

export default ModalBody;
